// react
import _ from "lodash";
import { useRouter } from "next/router";

// comps
import { Card, Row, Col, Button } from "antd";
import Icon from "@ant-design/icons";
import UserInfoBlock from "~/components/users/UserInfoBlock";
import EditIcon from "~/components/app/EditIcon";

// redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { showAppModal } from "~/redux/actions/app";

const NewPostCard = (props) => {
  const { category, hideNewPost = false, hideNewJob = false } = props;
  const router = useRouter();

  const handleLinkToNewPost = () => {
    if (props.token) {
      let path = "/posts/new";
      if (category) {
        path += `?category=${category.id}`;
      }
      router.push(path);
    } else {
      props.showAppModal("PhoneSigninModal");
    }
  };

  const handleLinkToNewJob = () => {
    if (props.token) {
      props.showAppModal("NewJobModal");
    } else {
      props.showAppModal("PhoneSigninModal");
    }
  };

  const handleLinkToMyPosts = (kind) => {
    if (props.token) {
      let path = "/profile/posts";
      router.push(
        {
          pathname: path,
          query: {
            categoryKind: kind,
          },
        },
        path
      );
    } else {
      props.showAppModal("PhoneSigninModal");
    }
  };

  // 控制移动端按钮的宽度，如果有两个按钮，则各占一半，否则全宽
  const mobileSpan = !hideNewJob && !hideNewPost ? 12 : 24;
  const simpleMode = props.simpleMode || !props.token;

  const postSummary = _.get(props, "currentUser.post_summary", {});

  const renderNewJobButton = () => {
    return (
      <Button
        type="primary"
        icon={
          <Icon
            component={EditIcon}
            style={{ color: "white" }}
          />
        }
        onClick={handleLinkToNewJob}
        block
      >
        发布招聘
      </Button>
    );
  };

  const renderNewPostButton = () => {
    return (
      <Button
        type="primary"
        icon={
          <Icon
            component={EditIcon}
            style={{ color: "white" }}
          />
        }
        onClick={handleLinkToNewPost}
        block
      >
        发布话题
      </Button>
    );
  };

  const renderPostsSummary = (count, ongoingCount, title) => {
    return (
      <div className="posts-summary">
        <div className="posts-summary-count">
          <span className="count">{count}</span>
          {count > 0 && ongoingCount > 0 && (
            <span className="ongoing-count">（{ongoingCount}进行中）</span>
          )}
        </div>
        <div className="posts-summary-title">{title}</div>
      </div>
    );
  };

  if (simpleMode) {
    return (
      <Card className={`new-post-card ${props.className}`}>
        <Row gutter={[8, 8]}>
          {!hideNewPost && (
            <Col
              xs={mobileSpan}
              sm={mobileSpan}
              md={24}
            >
              {renderNewPostButton()}
            </Col>
          )}
          {!hideNewJob && (
            <Col
              xs={mobileSpan}
              sm={mobileSpan}
              md={24}
            >
              {renderNewJobButton()}
            </Col>
          )}
        </Row>
      </Card>
    );
  } else {
    return (
      <Card className={`new-post-card ${props.className}`}>
        <Row>
          <Col span={24}>
            <UserInfoBlock
              user={props.currentUser}
              withResume
              withEditIcon
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <div
              style={{
                border: "1px solid #f8f8f8",
                width: "100%",
                height: 0,
                margin: "6px 0",
              }}
            />
          </Col>
        </Row>
        <Row gutter={[8, 8]}>
          <Col
            span={12}
            onClick={handleLinkToMyPosts.bind(null, "talk")}
          >
            {renderPostsSummary(
              postSummary.talk_posts_count || 0,
              null,
              "我发布的话题帖"
            )}
          </Col>
          <Col
            span={12}
            onClick={handleLinkToMyPosts.bind(null, "work")}
          >
            {renderPostsSummary(
              postSummary.recruitment_posts_count || 0,
              postSummary.open_recruitment_posts_count || 0,
              "我发布的招聘帖"
            )}
          </Col>
        </Row>
        <Row gutter={[8, 8]}>
          {!hideNewPost && <Col span={mobileSpan}>{renderNewPostButton()}</Col>}
          {!hideNewJob && <Col span={mobileSpan}>{renderNewJobButton()}</Col>}
        </Row>
      </Card>
    );
  }
};

const mapStateToProps = (state) => ({
  token: state.user.token,
  currentUser: state.user.user,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAppModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(NewPostCard);
